import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async update ({ state, dispatch }) {
    try {
      const { data } = await directus.getMe()
      console.log(data)
      await directus.updateUser(data.id, {
        password: state.password
      })
      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
